import reducer from './gdpr.reducer'
import * as actions from './gdpr.actions'

export {
    reducer,
    actions,
}



// WEBPACK FOOTER //
// /src/js/common/gdpr/index.js